import { render, staticRenderFns } from "./SELF_STATUS.vue?vue&type=template&id=dc654172&"
import script from "./SELF_STATUS.vue?vue&type=script&lang=js&"
export * from "./SELF_STATUS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports